import * as cacheManager from "./cache"

function getAllDepartments() {
    return cacheManager.getActiveCache('getAllDepartments');
}

function getSemester(term) {
    let semester = parseInt(term) % 10;
    let base;
    if (semester === 4) {
        base = 1014;
        semester = 'Spring ';
    } else if (semester === 2) {
        base = 1022;
        semester = 'Fall '
    } else {
        base = 1016;
        semester = 'Summer '
    }
    return semester + (((parseInt(term) - base) / 10 + 2001)).toString();
}

function getCapitalName(name) {
    return name.toLowerCase().replace(/^\w|\s\w|-\w|\'\w/g, l => l.toUpperCase());
}

export { getAllDepartments, getSemester, getCapitalName };


// WEBPACK FOOTER //
// ./src/common/utils.js